"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const components_1 = require("@/store/ducks/components");
const components_2 = require("@/services/components");
const listComponentsUseCase_1 = require("./listComponentsUseCase");
function createComponentUseCase(payload) {
    return async (dispatch) => {
        dispatch((0, components_1.saveChanges)());
        try {
            const numberOfComponents = await (0, components_2.countComponent)();
            payload.order = numberOfComponents.count++;
            await (0, components_2.postComponent)(payload);
            dispatch((0, components_1.saveChangesSuccess)());
            dispatch((0, components_1.openComponentToast)());
            await (0, listComponentsUseCase_1.listComponents)()(dispatch);
            dispatch((0, components_1.closeComponentModal)());
        }
        catch (error) {
            dispatch((0, components_1.saveChangesError)());
            dispatch((0, components_1.openComponentToast)());
        }
    };
}
exports.default = createComponentUseCase;
